import React from "react";
import { IBaseTag } from "@common/redux/types/tags";
import styles from "./Tag.module.scss";
import classNames from "classnames";

interface IProps {
  tag: IBaseTag;
  onClick?: (arg0: IBaseTag) => void;
  selected?: boolean;
}

export const Tag = ({ tag, onClick, selected }: IProps) => {
  return (
    <div
      className={classNames(styles.wrapper, selected && styles.selected, onClick && styles.clickable)}
      onClick={() => onClick ? onClick(tag) : null}
    >
      <div className={styles.title}>{tag.name}</div>
      {tag.count && <div className={styles.count}>{tag.count}</div>}
    </div>
  )
}
